<template>
  <div v-show="!needhide">
      <el-row :gutter="20">
        <el-col :span="6" :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <i class="el-icon-star-off iconstyle"></i>
              <span class="title">{{ yearmonth }}月销售总额</span>
            </div>
            <div class="bigfont">
                 {{paneldata[0]}}
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <i class="el-icon-check iconstyle"></i>
              <span>{{ yearmonth }}月退货金额</span>
            </div>
            <div class="bigfont">
              {{paneldata[1]}}
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <i class="el-icon-upload iconstyle"></i>
              <span>{{ yearmonth }}月佣金总额</span>
            </div>
            <div class="bigfont">
              {{paneldata[2]}}
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <i class="el-icon-user iconstyle"></i>
              <span>分销商人数</span>
            </div>
            <div class="bigfont">
              {{paneldata[3]}}
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="mt15">
        <el-card class="box-card">
                  <el-table
                  :data="tabledata"
                  style="width: 100%">
                  <el-table-column
                    label="年月"
                    width="180"
                    >
                    <el-select v-model="yearmonth" placeholder="选择年月"  @change="getList">
                      <el-option
                        v-for="item in datelist"
                        :key="item"
                        :label="item"
                        :value="item"
                        >
                      </el-option>
                    </el-select>
                  </el-table-column>
                  <el-table-column
                    prop="xs"
                    label="销售总额"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="th"
                    label="退货总额">
                  </el-table-column>
                  <el-table-column
                    prop="bonus"
                    label="佣金总额">
                  </el-table-column>
                  <el-table-column
                    prop="total"
                    label="销售总额">
                  </el-table-column>
                  <el-table-column
                    prop="ratio"
                    label="比例">
                  </el-table-column>
                </el-table>
        </el-card>
      </el-row>

  </div> 
</template>
<script>
export default {
  name: 'index',
  data(){
    return{
        paneldata:{},
        tabledata:[],
        datelist:[],
        yearmonth:'',
        needhide:false
    }
  },
  created(){
     this.getList()
  },
  methods: {
        getList(){
          this.$post("/home/getIndexData",{yearmonth:this.yearmonth}).then((data)=>{
          if(data.result.success){
              this.paneldata=data.result.info.paneldata
              this.tabledata=data.result.info.tabledata
              this.datelist=data.result.info.datelist
              this.yearmonth=data.result.info.yearmonth
          }else{
              this.$message.error(data.result.info)
          }
            
        })
     } 
  }
}
</script>
<style scoped lang="scss">
.mt15{margin-top: 10px;}
.bigfont{font-size: 0.30rem;text-align: center;}
.title{font-size:0.25rem;}
.iconstyle{font-size:0.25rem!important;}
.clearfix{display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;}
</style>
